/** Backend may send this literal when no reason was provided; we show the translated fallback instead. */
export const NO_REASON_API_VALUE = "No reason provided";

/**
 * Returns the trip reason for display, or fallback when reason is missing or equals NO_REASON_API_VALUE.
 */
export function getDisplayTripReason(reason: string | undefined | null, fallback: string): string {
  return reason && reason !== NO_REASON_API_VALUE ? reason : fallback;
}
